export const LINKED_STUDENT_STATUS_EVENT = 'bpm:linked-student-navigation-status';
export function reportLinkedStudentNavigation(requestId, error = null) {
  window.dispatchEvent(new CustomEvent(LINKED_STUDENT_STATUS_EVENT, { detail: { requestId, error } }));
}
